<template>
  <svg height="24px" viewBox="0 0 24 24" width="24px" fill="#000000">
    <g>
      <path d="M0,0h24v24H0V0z" fill="none"/>
    </g>
    <g>
      <g>
        <path d="M15,3H5C3.9,3,3.01,3.9,3.01,5L3,19c0,1.1,0.89,2,1.99,2H19c1.1,0,2-0.9,2-2V9L15,3z M8,17c-0.55,0-1-0.45-1-1s0.45-1,1-1 s1,0.45,1,1S8.55,17,8,17z M8,13c-0.55,0-1-0.45-1-1s0.45-1,1-1s1,0.45,1,1S8.55,13,8,13z M8,9C7.45,9,7,8.55,7,8s0.45-1,1-1 s1,0.45,1,1S8.55,9,8,9z M14,10V4.5l5.5,5.5H14z"/>
      </g>
    </g>
  </svg>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "sendreporticon"
})
</script>